import styled from 'styled-components';

const ModalForm = styled.form`
  position: absolute;
  top: 50%;
  left: 50%;
  box-sizing: border-box;
  width: min(510px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  padding: 25px;
  transform: translate(-50%, -50%);
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 40px 40px 40px 0;
  background-color: #fff;
  outline: none;
`;

const ModalTitle = styled.div`
  margin-bottom: 10px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
`;

const ModalActions = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  margin-top: 60px;

  > button {
    min-width: 0;
  }

  @media (max-width: 520px) {
    gap: 20px;

    > button {
      width: calc(50% - 10px);
    }
  }
`;

export { ModalActions, ModalForm, ModalTitle };
